import { UserStats } from '@/model/data-object/UserStats'

export default function useUserStatsFactory() {
  const createFromObject = function(userStatsProxy: UserStats): UserStats {
    const userStats = new UserStats()
    userStats.visiblePosts = userStatsProxy.visiblePosts
    userStats.hiddenPosts = userStatsProxy.hiddenPosts
    userStats.subscribedUsers = userStatsProxy.subscribedUsers
    userStats.followers = userStatsProxy.followers
    userStats.reportedPostsAccepted = userStatsProxy.reportedPostsAccepted
    userStats.reportedPostsAll = userStatsProxy.reportedPostsAll
    userStats.postReplies = userStatsProxy.postReplies
    userStats.postRepliesUnseen = userStatsProxy.postRepliesUnseen
    userStats.blockedUsers = userStatsProxy.blockedUsers
    userStats.superLikesRemaining = userStatsProxy.superLikesRemaining
    userStats.superLikesGivenTotal = userStatsProxy.superLikesGivenTotal
    userStats.superLikesReceivedTotal = userStatsProxy.superLikesReceivedTotal
    if (userStatsProxy.superLikesEntitled) {
      userStats.superLikesEntitled = userStatsProxy.superLikesEntitled
    }

    return userStats
  }

  return { createFromObject }
}
